import React, { useState, useCallback, useContext } from "react";
import { Dimensions, StyleSheet, View, Text } from "react-native";
import palette from "~/styles/palette";
import Heading from "../../../components/Heading/index";
import Paragraph from "../../../components/Paragraph/index";
import SolidButton from "../../../components/Buttons/SolidButton/index";
import Logo from "../../../components/Logo/index";
import PhoneInput from "../../../components/PhoneInput/index";
import Engage from "../../../services/engage";
import OnboardingContext from "../../../contexts/OnboardingContext";

export default function PhoneVerificationStep({ nextStep }) {
  const { verificationPhone: phone, setVerificationPhone } = useContext(OnboardingContext)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const onNext = useCallback(async () => {
    if (!loading) {
      setLoading(true);
      const res = await Engage.verifyPhoneNumber(phone);
      if (res.status === 200) {
        nextStep();
      } else {
        setError(res.message);
      }
      setLoading(false);
    }
  }, [loading, phone, setError, setLoading, nextStep]);

  return (
    <View
      style={{
        height: 400,
        padding: 24,
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <View style={{ alignItems: "center" }}>
        <Logo height={70} width={70} />
      </View>

      <View>
        <Heading center mb={0} mt={10}>
          Verify your number
        </Heading>
      </View>

      <View style={{ justifyContent: "center", flex: 1 }}>
        <Paragraph center mb={30}>
          We will text a code to the mobile number provided below. Once you
          receive it, use it to verify your number.
        </Paragraph>
      </View>

      <View style={{ marginBottom: 30 }}>
        <PhoneInput
          onChange={setVerificationPhone}
          placeholder="Enter your phone number"
          keyboardType="phone-pad"
        />
      </View>

      <View>
        <SolidButton
          loading={loading}
          label="Send Verification Code"
          color={palette.primary}
          onPress={onNext}
        />
      </View>
    </View>
  );
}
